import { useTranslation } from "react-i18next";
import { setIsOpen, toggleAdminMode } from 'store/slices/businessSlice';
import React from 'react';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Collapse, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem, Navbar, UncontrolledDropdown } from 'reactstrap';
import adminlogo from '../../assets/img/admin.png';
import userlogo from '../../assets/img/non_admin.png';
import logo from '../../assets/logo_green_tm.png';
import './Header.css';
import Logout from './Logout';
import { ModernAPI } from '../../Modules/ModernAPI';
const links = [{
  to: '/',
  text: 'Home',
  className: 'nav-link'
}, {
  to: '/learn',
  text: 'Learn',
  className: 'nav-link'
}, {
  to: '/signup',
  text: 'Sign Up',
  className: 'nav-link'
}];
const Authlinks = [{
  to: '/my-profile',
  text: 'My Profile',
  className: 'nav-link'
}, {
  to: '/personal/cards',
  text: 'Manage Cards',
  className: 'nav-link'
}, {
  to: '/personal/connections',
  text: 'Connections',
  className: 'nav-link'
}, {
  to: '/personal/qrCodes',
  text: 'QR Codes',
  className: 'nav-link'
}, {
  to: '/send-invite',
  text: 'Send Invitation',
  className: 'nav-link'
}, {
  to: '/pricing',
  text: 'Pricing',
  className: 'nav-link'
}];
// eslint-disable-next-line no-unused-vars
const AdminLinks = [{
  to: '/admin/database',
  text: 'Database',
  className: 'nav-link'
}, {
  to: '/admin/users',
  text: 'Users',
  className: 'nav-link'
}, {
  to: '/admin/connections',
  text: 'Connections',
  className: 'nav-link'
}, {
  to: '/admin/invitations',
  text: 'Invitations',
  className: 'nav-link'
}, {
  to: '/admin/messages',
  text: 'Messages',
  className: 'nav-link'
}, {
  to: '/admin/audit',
  text: 'Audit Logs',
  className: 'nav-link'
}];
const NoAuthlinks = [{
  to: '/login',
  text: 'Login',
  className: 'nav-link'
}, {
  to: '/faqs',
  text: 'FAQs',
  className: 'nav-link'
}];

const createNavItem = (item, t) => {
  return <NavItem key={item.to}>
    <NavLink exact to={item.to} className={item.className}>{t(item.text)}</NavLink>
  </NavItem>;
};

function Header(props) {
  const {
    t,
    i18n
  } = useTranslation();
  const {
    isAuthenticated,
    isAdmin,
    isOpen,
    setIsOpen,
    adminMode,
    toggleAdminMode,
    currentUser
  } = props;
  console.log('Header props:', {
    isAuthenticated,
    isAdmin,
    isOpen,
    adminMode,
    currentUser
  });
  return <Navbar light className="fixed-header bg-white" style={{
    marginBottom: 0
  }} justify='true' expand='lg'>
      <a href='/'><img src={logo} alt={t("HeresMyInfo")} className="header-logo" /></a>

      {isAuthenticated && isAdmin && <Nav className='nav-pills me-2 mr-2'>
          <NavItem>
            <Link to={adminMode ? '/' : '/admin'} className='admin-link' onClick={() => {
          toggleAdminMode();
        }}>
              <img src={adminMode ? userlogo : adminlogo} title={adminMode ? 'user mode' : 'admin mode'} alt={adminMode ? 'user mode' : 'admin mode'} className='adminLogo' />
            </Link>
          </NavItem>
        </Nav>}

      <button type="button" className="navbar-toggler" onClick={() => setIsOpen(!isOpen)} style={{
      borderColor: 'rgba(0,0,0,0.1)',
      padding: '4px 8px'
    }}>
        <svg viewBox="0 0 100 80" width="24" height="24" fill="black">
          <rect width="100" height="15" rx="8"></rect>
          <rect y="30" width="100" height="15" rx="8"></rect>
          <rect y="60" width="100" height="15" rx="8"></rect>
        </svg>
      </button>
      <Collapse isOpen={isOpen} navbar style={{
      justifyContent: 'flex-end',
      color: 'var(--minimal-text-primary)'
    }}>
        <Nav navbar id='nav-header' className='nav-pills ml-auto ms-auto bg-white' style={{
        lineHeight: '1rem'
      }}>
          {!isAuthenticated && <>
              {links.map(item => createNavItem(item, t))}
            </>}
          {isAuthenticated && <>
              {Authlinks.map(item => createNavItem(item, t))}
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>{t("More")}</DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem header>{t('Account')}</DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/my-profile' className='nav-link'>{t('My Profile')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/faqs' className='nav-link'>{t('FAQs')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/learn' className='nav-link'>{t("Learn")}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/resetPassword' className='nav-link'>{t('Reset Password')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem header>{t('Manage')}</DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/personal/merged-contacts' className='nav-link'>{t('Merged Contacts')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/personal/backupDownload' className='nav-link'>{t('Download Contact Backups')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/personal/delete' className='nav-link'>{t('Delete Account')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem header>{t("Business")}</DropdownItem>
                  <DropdownItem>
                    <NavItem>
                      <NavLink exact to='/business' className='nav-link'>{t('Claim a Business')}</NavLink>
                    </NavItem>
                  </DropdownItem>
                  <DropdownItem divider />

                  <DropdownItem>
                    <NavItem>
                      <Logout className='ml-auto' />
                    </NavItem>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              
              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                  <span role="img" aria-label="globe" style={{
                marginRight: '4px'
              }}>🌐</span>
                  {i18n.language ? i18n.language.toUpperCase().split('-')[0] : 'EN'}
                </DropdownToggle>
                <DropdownMenu right>
                  {[
                    { code: 'en', label: 'English' },
                    { code: 'es', label: 'Español' },
                    { code: 'it', label: 'Italiano' },
                    { code: 'de', label: 'Deutsch' },
                    { code: 'zh', label: '中文' },
                    { code: 'ja', label: '日本語' },
                    { code: 'da', label: 'Dansk' },
                    { code: 'uk', label: 'Українська' },
                    { code: 'pt', label: 'Português' },
                  ].map(lang => (
                    <DropdownItem key={lang.code} onClick={() => {
                      i18n.changeLanguage(lang.code);
                      if (isAuthenticated) {
                        ModernAPI.updateProfile({ language: lang.code }).catch(err => console.error('Failed to update language', err));
                      }
                    }}>
                      {lang.code === 'zh' || lang.code === 'ja' || lang.code === 'uk' ? lang.label : t(lang.label)}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            </>}
          {!isAuthenticated && <>
              {NoAuthlinks.map(item => createNavItem(item, t))}
            </>}
        </Nav>
        {isAuthenticated && currentUser && <Nav navbar className="user-nav ml-lg-2 ms-lg-2">
            <NavItem className="d-flex align-items-center px-1 px-lg-2">
              <span className="navbar-text font-weight-bold navbar-user-text" title={currentUser.username || currentUser.email} style={{
            color: 'var(--minimal-text-primary)'
          }}>
                {currentUser.username || currentUser.email}
              </span>
            </NavItem>
          </Nav>}
      </Collapse>
    </Navbar>;
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isAdmin: state.auth.isAuthenticated && state.auth.currentUser && state.auth.currentUser.isAdmin === true,
    isOpen: state.business.isOpen,
    adminMode: state.business.adminMode || false,
    currentUser: state.auth.currentUser
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  setIsOpen: toggle => dispatch(setIsOpen(toggle)),
  toggleAdminMode: () => {
    console.log('=== ADMIN MODE TOGGLE ===');
    console.log('Current path:', ownProps.history.location.pathname); // Get current state from Redux store

    const store = require('../../store').default;

    const currentState = store.getState();
    const currentAdminMode = currentState.business.adminMode;
    const userIsAdmin = currentState.auth.isAuthenticated && currentState.auth.currentUser && currentState.auth.currentUser.isAdmin === true;
    console.log('Current admin mode from store:', currentAdminMode);
    console.log('User is admin:', userIsAdmin); // Only allow admin mode toggle if user has admin privileges

    if (!userIsAdmin) {
      console.log('User does not have admin privileges - cannot toggle admin mode');
      return;
    }

    dispatch(toggleAdminMode());
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));